import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table table-striped" }
const _hoisted_5 = { class: "mx-auto text-center fixed-columns" }
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = { class: "btn-group float-end" }

import Layout from "@/components/Layout.vue";
import Navigation from "@/components/Navigation.vue";
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref} from "vue";
import {MainService} from "@/services/main.service";
import {ResultModel} from "@/models/result.model";
import {useTranslate} from "@/hooks/translate.hook";


export default /*#__PURE__*/_defineComponent({
  __name: 'TestResultView',
  setup(__props) {

const t = useTranslate()
const route = useRoute()
const router = useRouter()
const result = ref<ResultModel>()

onMounted(async () => {
  try {
    const id = Number.parseInt(route.params.id as string)
    const rsp = await MainService.getStudentTestResult(id)
    result.value = rsp.data
  } catch (e) {
    await router.push({
      path: '/list'
    })
  }
})

function generateTestTitle() {
  if (result.value == undefined)
    return t('page.result.text.error')

  if (result.value?.isStopped == true) {
    return t('page.result.text.stopped')
  }

  if (result.value?.deadlineReached == true) {
    return t('page.result.text.deadline')
  }

  if (result.value?.points < (result.value?.maxPoints / 2)) {
    return t('page.result.text.failed')
  }

  return t('page.result.text.passed')
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation),
    _createVNode(Layout, null, {
      main: _withCtx(() => [
        (result.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)('page.result.title')), 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("tbody", _hoisted_5, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_6, [
                        _createElementVNode("h3", null, _toDisplayString(generateTestTitle()), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_unref(t)('page.result.subject')), 1),
                      _createElementVNode("th", null, _toDisplayString(result.value.subjectName), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_unref(t)('page.result.test')), 1),
                      _createElementVNode("th", null, _toDisplayString(result.value.testName), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_unref(t)('page.result.points')), 1),
                      _createElementVNode("th", null, _toDisplayString(result.value.points) + "/" + _toDisplayString(result.value.maxPoints), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_RouterLink, {
                    to: "/list",
                    class: "btn btn-sm btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('page.result.back')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})